export default __webpack_public_path__ + "static/media/00.114be095.jpg";